import { createSelector } from 'reselect';

import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * Returns the list of setup labor tickets for the current work order operation.
 * Includes tickets from work order operation and the current labor ticket if it
 * is a setup ticket and not already in the list. Returns [] when NATS flow is
 * disabled or there are no setup tickets.
 */
const getSetupLaborTicketsForOperation = createSelector(
  [getWorkOrderManagement, getPostLaborUpdatesOnNats, getCurrentLaborTicket],
  (workOrderManagement, natsFlowEnabled, currentLaborTicket) => {
    if (!natsFlowEnabled) {
      return [];
    }

    const workOrderOperationLaborTickets =
      workOrderManagement?.workOrderOperationLaborTickets || [];

    let setupTickets = workOrderOperationLaborTickets.filter((ticket) => {
      return ticket.type?.toLowerCase() === 'setup';
    });

    if (
      currentLaborTicket?.type?.toLowerCase() === 'setup' &&
      !setupTickets.find((t) => {
        return t.laborTicketId === currentLaborTicket.laborTicketId;
      })
    ) {
      setupTickets = [...setupTickets, currentLaborTicket];
    }

    return setupTickets;
  }
);

export { getSetupLaborTicketsForOperation };
